<template>
  <div class="navbar">
    <div style="float: left" v-if="isNav">
      <top-nav id="topmenu-container" class="topmenu-container" />
    </div>

    <div class="right-menu flex align-center" style="color: #fff;background-color: rgba(3, 11, 31, 1);">
      <div>{{ userStore.nickname }} {{ userStore.phone }}</div>
      <div class="avatar-container">
        <el-dropdown class="right-menu-item hover-effect" trigger="click" @command="handleCommand">
          <div class="avatar-wrapper">
            <img :src="userStore.avatar" class="user-avatar" />
            <el-icon style="position: absolute; top: 20px"><caret-bottom /></el-icon>
          </div>
          <template #dropdown>
            <el-dropdown-menu>
              <!-- <router-link to="/user/profile">
                <el-dropdown-item>{{ $t('navbar.personalCenter') }}</el-dropdown-item>
              </router-link> -->
              <!-- <el-dropdown-item v-if="settingsStore.showSettings" command="setLayout">
                <span>{{ $t('navbar.layoutSetting') }}</span>
              </el-dropdown-item> -->

              <el-dropdown-item command="logout">
                <span>{{ $t('navbar.logout') }}</span>
              </el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </div>
    </div>

    <div class="right-menu text-white mr-4">
      <LangSelect />
    </div>
    <!-- <div class="right-menu text-white mr-4">
      <el-select v-if="userId === 1 && tenantEnabled" v-model="companyName" class="min-w-244px" clearable
        :placeholder="proxy.$t('navbar.selectTenant')" @change="dynamicTenantEvent"
        @clear="dynamicClearEvent">
        <el-option v-for="item in tenantList" :key="item.tenantId" :label="item.companyName" :value="item.tenantId">
        </el-option>
        <template #prefix><svg-icon icon-class="company" class="el-input__icon input-icon" /></template>
      </el-select>
    </div> -->
  </div>
</template>

<script setup lang="ts">
import useAppStore from '@/store/modules/app';
import useUserStore from '@/store/modules/user';
import useSettingsStore from '@/store/modules/settings';
import useNoticeStore from '@/store/modules/notice';
import { getTenantList } from '@/api/login';
import { dynamicClear, dynamicTenant } from '@/api/system/tenant';
import { TenantVO } from '@/api/types';
import LangSelect from '@/components/LangSelect/index.vue';
import { useI18n } from 'vue-i18n';
import { onMounted } from 'vue';
import { initSSE } from '@/utils/sse';
import { getTenantLoginUrl } from '@/utils/tenantRoute';
const userStore = useUserStore();

const { t } = useI18n();
const selTan = ref(null);
defineProps({
  isNav: {
    type: Boolean,
    default: true
  }
});

const appStore = useAppStore();
const settingsStore = useSettingsStore();
const noticeStore = storeToRefs(useNoticeStore());
const newNotice = ref(<number>0);
// const companyName = ref(undefined);
  
const { proxy } = getCurrentInstance() as ComponentInternalInstance;

const userId = ref(userStore.userId);
const tenantId = ref(undefined);
const tenantList = ref<TenantVO[]>([]);
// 是否切换了租户
const dynamic = ref(false);
// 租户开关
const tenantEnabled = ref(true);


// 动态切换
// const dynamicTenantEvent = async (tenantId: string) => {
//   if (companyName.value != null && companyName.value !== '') {
//     await dynamicTenant(tenantId);
//     dynamic.value = true;
//     await proxy?.$router.push('/');
//     await proxy?.$tab.closeAllPage();
//     await proxy?.$tab.refreshPage();
//     userStore.setTenantId(tenantId);
//   }
// };

const dynamicClearEvent = async () => {
  await dynamicClear();
  dynamic.value = false;
  proxy?.$tab.closeAllPage();
  proxy?.$router.push('/');
  proxy?.$tab.refreshPage();
};

// /** 租户列表 */
// const initTenantList = async () => {
//   const { data } = await getTenantList();
//   tenantEnabled.value = data.tenantEnabled === undefined ? true : data.tenantEnabled;
//   if (tenantEnabled.value) {
//     tenantList.value = data.voList;
//     companyName.value = userStore.tenantId;
//   }
// };

onMounted(() => {
  initSSE(import.meta.env.VITE_APP_BASE_API + '/resource/sse');
  // initTenantList();
});

const toggleSideBar = () => {
  appStore.toggleSideBar(false);
};

/**
 * 注销当前用户并跳转到携带当前租户 ID 的登录页。
 * @returns {Promise<void>} 注销接口完成并触发整页跳转后结束
 * @sideeffect 清除用户登录态，并通过 location.href 重新加载登录页
 */
const logout = async () => {
  await ElMessageBox.confirm(t('navbar.logoutConfirmMessage'), t('navbar.logoutConfirmTitle'), {
    confirmButtonText: t('navbar.confirm'),
    cancelButtonText: t('navbar.cancel'),
    type: 'warning'
  });
  // 必须在 logout 清理登录态之前保存租户 ID，避免后续 Store 重置导致跳转地址丢失租户信息。
  const logoutTenantId = userStore.tenantId;
  await userStore.logout();
  location.href = getTenantLoginUrl(logoutTenantId);
};

const emits = defineEmits(['setLayout']);
const setLayout = () => {
  emits('setLayout');
};
// 定义Command方法对象 通过key直接调用方法
const commandMap: { [key: string]: any } = {
  setLayout,
  logout
};
const handleCommand = (command: string) => {
  // 判断是否存在该方法
  if (commandMap[command]) {
    commandMap[command]();
  }
};
//用深度监听 消息
watch(
  () => noticeStore.state.value.notices,
  (newVal) => {
    newNotice.value = newVal.filter((item: any) => !item.read).length;
  },
  { deep: true }
);
</script>

<style lang="scss" scoped>
.tenIcon {
  width: 18px;
  height: 18px;
  font-size: 18px;
  background-color: #fff;
  border-radius: 2px;
}

:deep(.el-select .el-input__wrapper) {
  height: 30px;
}

:deep(.el-badge__content.is-fixed) {
  top: 12px;
}

.flex {
  display: flex;
}

.align-center {
  align-items: center;
}

.navbar {
  width: calc(100vw - 320px);
  height: 50px;
  overflow: hidden;
  position: relative;
  background: rgba(3, 11, 31, 1);

  .hamburger-container {
    line-height: 46px;
    height: 100%;
    float: left;
    cursor: pointer;
    transition: background 0.3s;
    -webkit-tap-highlight-color: transparent;

    &:hover {
      background: rgba(0, 0, 0, 0.025);
    }
  }

  .breadcrumb-container {
    float: left;
  }

  .topmenu-container {
    position: absolute;
    left: 0px;
    background-color: rgba(3, 11, 31, 1);
  }

  .errLog-container {
    display: inline-block;
    vertical-align: top;
  }

  .right-menu {
    float: right;
    height: 100%;
    line-height: 50px;
    display: flex;
    align-items: center;

    &:focus {
      outline: none;
    }

    .right-menu-item {
      display: inline-block;
      padding: 0 8px;
      height: 100%;
      font-size: 18px;
      color: #5a5e66;
      vertical-align: text-bottom;

      &.hover-effect {
        cursor: pointer;
        transition: background 0.3s;

        &:hover {
          background: rgba(0, 0, 0, 0.025);
        }
      }
    }

    .avatar-container {
      margin-right: 40px;

      .avatar-wrapper {
        margin-top: 5px;
        position: relative;

        .user-avatar {
          cursor: pointer;
          width: 30px;
          height: 30px;
          border-radius: 50%;
          margin-top: 10px;
          border: 2px solid #fff;
        }

        i {
          cursor: pointer;
          position: absolute;
          right: -20px;
          top: 25px;
          font-size: 12px;
        }
      }
    }
  }
}
</style>
